import { connect } from 'react-redux';
import { IApplicationState, TTypedThunkDispatch } from '../../../types/store';

import { StationDirections } from '.';
import { IStations } from '../../../store/stations';
import { onChangeStationDirection } from '../../../store/stations/actions';

export interface IStationDirectionsProps {
  stations: IStations;
}

export interface IStationDirectionsDispatchProps {
  onChangeStationDirection(value: number): void;
}

export type TStationDirectionsProps = IStationDirectionsProps & IStationDirectionsDispatchProps;

export function mapStateToProps(state: IApplicationState): IStationDirectionsProps {
  const { stations } = state;

  return {
    stations,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): IStationDirectionsDispatchProps {
  return {
    onChangeStationDirection: value => dispatch(onChangeStationDirection(value)),
  };
}

export const StationDirectionsContainer = connect<IStationDirectionsProps, IStationDirectionsDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(StationDirections);
